/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Frontend SPA Contract API
 * Canonical API contract entrypoint.
 *
 * Source architecture:
 * - split by module / bounded context
 * - one file per aggregate root
 * - child entities remain owned by aggregate root
 * - cross-cutting technical concerns live under `openapi/common`
 *
 * OpenAPI spec version: 1.0.0
 */
import type {SupplierFunctionAssignmentInput, SupplierFunctionId, SupplierId} from "../model";

import {customFetch} from "../../../runtime/custom-fetch";

export const getAddSupplierFunctionUrl = (id: SupplierId) => {
  return `/api/v1/engineering/suppliers/${id}/functions`;
};

/**
 * @summary Add supplier function
 */
export const addSupplierFunction = async (
  id: SupplierId,
  supplierFunctionAssignmentInput: SupplierFunctionAssignmentInput,
  options?: Parameters<typeof customFetch>[1],
): Promise<SupplierFunctionId> => {
  return customFetch<SupplierFunctionId>(getAddSupplierFunctionUrl(id), {
    ...options,
    method: "POST",
    headers: {"Content-Type": "application/json", ...options?.headers},
    body: JSON.stringify(supplierFunctionAssignmentInput),
  });
};

export const getRemoveSupplierFunctionUrl = (id: SupplierId, functionId: SupplierFunctionId) => {
  return `/api/v1/engineering/suppliers/${id}/functions/${functionId}`;
};

/**
 * @summary Remove supplier function
 */
export const removeSupplierFunction = async (
  id: SupplierId,
  functionId: SupplierFunctionId,
  options?: Parameters<typeof customFetch>[1],
): Promise<void> => {
  return customFetch<void>(getRemoveSupplierFunctionUrl(id, functionId), {
    ...options,
    method: "DELETE",
  });
};
